// TODO: (convo-reordering-after-full-migrations): remove sort_conversation_by_collaborator_comment_enabled
const preferences = `
  preferences {
    custom_profile_app_installed
    custom_profile_unsafe
    customer_ratings_installed
    groove_20_beta
    groove_legacy_access
    historical_reports
    reports_average
    scoped_contacts_search
    show_pinned_searches
    experimental_realtime_warnings
    mention_any_agent
    experimental_label_ui
    self_help_cancellation
    ticket_preloading
    chat_room_id
    should_use_fixed_drafts_v2
    should_use_notes_v2
    crm_sidebar
    debug_frontend
    chat_enabled
    sort_conversation_by_collaborator_comment_enabled
    mail_chimp_installed
    team_chat_app
    campaign_monitor_installed
    constant_contact_installed
    evoice_installed
    two_factor_authentication_installed
    outbound_email_branding_disabled
    skip_email_beacon
    unified_inbox
    v2_show_all_mailboxes_section
  }
`

export const basicFields = `
  id
  subdomain
  name
  stripe_last4
  primary_knowledge_base_id
  is_onboarding_completed
  has_v2_widgets
  industry
  timezone
  ${preferences}
`

export const withIntegrationsSettings = `
  ${basicFields}
  integrationSettings {
    provider
    value
  }
`

export const accountQuery = () => `
  query AccountQuery {
    account {
      ${withIntegrationsSettings}
    }
  }
`

export const accountPreferencesQuery = `
  query AccountPreferencesQuery {
    account {
      ${preferences}
    }
  }
`

export const accountPreferenceQuery = preference => `
  query AccountPreferenceQuery {
    account {
      preferences {
        ${preference}
      }
    }
  }
`

export const updateAccountMutation = `
  mutation UpdateAccount($input: AccountUpdateInput!) {
    updateAccount(input: $input) {
      ${basicFields}
    }
  }
`
